// extracted by mini-css-extract-plugin
export default {"wrap":"hK-z","fullWidth":"iK-z","hideOnDesktop":"jK-z","content":"kK-z","hasOpenedNav":"lK-z","crumbsList":"mK-z","dropdownsWrap":"nK-z"};